/** Service Desk console, detalye ng ticket: kagamitan, kontrata, mga visit, RMA, child ticket at pag-resolve kahit bukas ang mga child (SD-S3-10, TKT-143). */
export const serviceTicketAfterSales = {
  equipment: {
    title: "Kagamitan",
    none: "Walang kagamitang binanggit sa ticket na ito.",
    error: "Hindi ma-load ang kagamitan.",
    more: "{{count}} pa ang hindi ipinapakita.",
  },
  contract: {
    title: "Kontrata",
    noneChip: "Walang kontrata",
    none: "Walang aktibong kontratang sumasakop sa ticket na ito: may bayad ang trabaho maliban kung sakop ng warranty.",
    error: "Hindi ma-load ang saklaw ng kontrata.",
    viaAsset: "Sumasakop sa kagamitan sa ticket na ito.",
    viaOrganisation: "Sumasakop sa buong organisasyon.",
  },
  visits: {
    title: "Mga field visit",
    none: "Walang naka-planong visit para sa ticket na ito.",
    error: "Hindi ma-load ang mga visit.",
    schedule: "Mag-iskedyul ng visit",
  },
  rmas: {
    title: "Mga return (RMA)",
    none: "Walang sinimulang return, pagkukumpuni o pagpapalit.",
    error: "Hindi ma-load ang mga return.",
    create: "Gumawa ng RMA",
  },
  children: {
    title: "Mga child ticket",
    none: "Walang child ticket. Hatiin ang trabaho kapag higit sa isa ang kailangan.",
    isChild: "Bahagi ng mas malaking ticket ang ticket na ito.",
    error: "Hindi ma-load ang mga child ticket.",
    progress: "{{done}} sa {{total}} ang resolved",
    hidden: "{{count}} pa na hindi mo mabubuksan ang kasama sa progreso.",
    limit: "Hanggang {{max}} child ticket lang ang kaya ng isang ticket.",
    create: "Gumawa ng child ticket",
    createTitle: "Gumawa ng child ticket",
    createBody: "Bagong ticket sa ilalim ng {{number}}.",
    createSubmit: "Gumawa ng child ticket",
    created: "Nagawa ang child ticket na {{number}}",
    inherits: "Pananatilihin nito ang organisasyon, site, requester at kagamitan ng parent ({{organisation}}).",
    noOrganisation: "walang organisasyon",
    titleLabel: "Pamagat",
    descriptionLabel: "Ano ang kailangang gawin",
    problemTitle: "Maglagay ng pamagat na hindi bababa sa {{min}} character.",
    notify: "Sabihan ang client tungkol sa ticket na ito",
    notifyHint: "Karaniwang panloob na trabaho ang child, kaya hindi sasabihan ang client maliban kung hihilingin mo.",
  },
  forceResolve: {
    open_one: "{{count}} child ticket ang bukas pa.",
    open_other: "{{count}} child ticket ang bukas pa.",
    blocked: "Bukas pa ang mga child ticket. Isara muna ang mga ito; ang may karapatang mag-manage ng ticket lang ang puwedeng mag-resolve kahit bukas ang mga ito.",
    reason: "Bakit ka nagre-resolve pa rin",
    hint: "Hindi bababa sa {{min}} character. Itatago ito sa ticket at sa audit trail.",
    reasonRequired: "Maglagay ng dahilang hindi bababa sa {{min}} character.",
    submit: "I-resolve pa rin",
  },
} as const;
